export default __webpack_public_path__ + "static/media/item-order.23515f6d.png";